/**
 * MotionX runtime fallbacks — 与 globals.css 品牌变量保持一致。
 * UI 组件请优先使用 CSS 变量（var(--mx-*)），Canvas 通过 read*Palette() 读取。
 */
export const brand = {
  obsidian:          '#18181B',
  green:             '#6db5a8',
  greenSecondary:    '#5a9e92',
} as const;

export const mx = {
  skeleton:     brand.green,
  skeletonDim:  brand.greenSecondary,
  skeletonFace: '#b8c0cc',
} as const;

export function scoreTier(score: number) {
  if (score >= 90) return { label: '优秀', color: 'var(--mx-success)' };
  if (score >= 70) return { label: '良好', color: 'var(--mx-accent)' };
  if (score >= 50) return { label: '一般', color: 'var(--mx-warning)' };
  return { label: '待改进', color: 'var(--mx-danger)' };
}

export interface SkeletonPalette {
  primary: string;
  secondary: string;
  face: string;
}

export interface StagePalette {
  top: string;
  mid: string;
  bottom: string;
  grid: string;
  scan: string;
  vignette: string;
}

function cssVar(name: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

export function readSkeletonPalette(): SkeletonPalette {
  return {
    primary:   cssVar('--mx-skeleton', mx.skeleton),
    secondary: cssVar('--mx-skeleton-dim', mx.skeletonDim),
    face:      cssVar('--mx-skeleton-face', mx.skeletonFace),
  };
}

export function readStagePalette(): StagePalette {
  return {
    top:      cssVar('--mx-stage-top', brand.obsidian),
    mid:      cssVar('--mx-stage-mid', brand.obsidian),
    bottom:   cssVar('--mx-stage-bottom', brand.obsidian),
    grid:     cssVar('--mx-stage-grid', 'rgba(109,181,168,0.14)'),
    scan:     cssVar('--mx-stage-scan', 'rgba(109,181,168,0.05)'),
    vignette: cssVar('--mx-stage-vignette', 'rgba(24,24,27,0.55)'),
  };
}

export function jointColor(index: number, palette: SkeletonPalette): string {
  if (index <= 4) return palette.face;
  if ([5, 6, 11, 12].includes(index)) return palette.primary;
  return palette.secondary;
}
